import { msg } from "@lingui/core/macro";

export const permitTypeOverrideRuleMessages = {
	name: msg({
		message: "Permit Type Override",
		comment: "Name of the rule that blocks buying a parking option while an overriding permit type is active",
	}),
	description: msg({ message: "A parking option cannot be purchased while an overriding permit type is active" }),
	errors: {
		optionOverridden: msg({
			message:
				"This parking option is currently unavailable while the following is active: {overridingPermitTypeTitles}",
			comment:
				"Shown to a parker who tries to buy a parking option that is overridden right now; the placeholder is a locale-formatted list of one or more permit type titles",
		}),
	},
} as const;
